<template>
  <div class="annual-report-popup">
    <van-popup
      v-model="innerVisible"
      :close-on-click-overlay="false"
      round
    >
      <div class="popup-body">
        <div class="close-btn" @click="handleClose">
          <svg width="32" height="32" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="decoration"></div>
        <div class="decoration2"></div>
        <div class="content">
          <div class="subtitle">年度学习报告</div>
          <div class="arrow-btn" v-track="{ functionName: '年度学习报告-弹窗进入' }" @click="handleConfirm">
          </div>
          <div class="tips">可在【我的】页面，点击【专属的学习报告】查看。</div>
        </div>
        <div class="CR">022118-251216</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'AnnualReportPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerVisible: this.value
    }
  },
  watch: {
    value(val) {
      this.innerVisible = val
    },
    innerVisible(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: 'Source Han Sans SC';
  src: url('/static/fonts/SOURCEHANSANSCN-MEDIUM.OTF') format('opentype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

.annual-report-popup {
  /deep/ .van-popup {
    background-color: transparent;
    overflow-y: visible;
    z-index: 10006 !important;
  }

  .popup-body {
    width: 286px;
    height: 437px;
    background: linear-gradient(180deg, #fce9e8 0%, #fcd5d2 100%);
    border-radius: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    font-family: 'Source Han Sans SC', 'PingFang SC', 'Helvetica Neue', sans-serif;

    .close-btn {
      position: absolute;
      top: 10px;
      right: 16px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
    }

    .decoration {
      width: 317px;
      height: 176px;
      background: url("~@/assets/images/activity/battery.png") no-repeat center center / 100% 100%;
      margin-top: -10px;
    }
    .decoration2 {
      width: 167px;
      height: 82px;
      margin-bottom: 8px;
      margin-top: 16px;
      background: url("~@/assets/images/activity/decoration.png") no-repeat center center / 100% 100%;
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 1;
    }

    .subtitle {
      font-size: 20px;
      color: #000;
      text-align: center;
      margin-bottom: 9px;
      letter-spacing: 8px;    /* 正值增加间距，负值减小 */
    }

    .arrow-btn {
      width: 88px;
      height: 84px;
      background: url("~@/assets/images/activity/button.png") no-repeat center center / 100% 100%;
    }
    .tips{
      font-size: 8px;
      color: #000;
      margin-top: 16px;

    }
  }
}
.CR{
  font-size: 5px;
  color: #000;
  width: 100%;
  padding-left: 20px;
}
/deep/ .van-overlay {
  z-index: 10005 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/AnnualReportPopup.vue